import React from 'react';
import Header from './components/header/GlobalHeader';
import { render } from 'react-dom';
import './creatori.css';
import Fixed from './components/Fixed/Fixed';
window.onscroll = function() {myFunction()};

function myFunction() {
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
  var scrolled = (winScroll / height) * 100;
  document.getElementById("myBar").style.width = scrolled + "%";
}

const headerElement = document.getElementById("header");
render(
  <React.StrictMode>
    <Header></Header>
  </React.StrictMode>,
  headerElement
);

const homeElement = document.getElementById("home");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <div className="oop"></div>
      <h1 className="large">Parallax Background</h1>
      <p>No JavaScript, Start scrolling</p>
    </Fixed>
  </React.StrictMode>,
  homeElement
);

const collezioneElement = document.getElementById("collezione");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <h1>Versione Developer / Tech</h1>
      <p>Component props state hooks render event handler. Lifecycles conditional rendering context API virtual DOM elements. Frontend development functional programming architecture interface layout styling modules. Deploy production build compilation package manager dependency route framework application.</p>
    </Fixed>
  </React.StrictMode>,
  collezioneElement
);

const atelierElement = document.getElementById("atelier");
render(
  <React.StrictMode>
    <Fixed >
      <>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
      </>
    </Fixed>
  </React.StrictMode>,
  atelierElement
);

const comeNasceElement = document.getElementById("comeNasce");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <>
        Massimizza il valore del tuo business con soluzioni innovative e su misura. Sviluppiamo strategie digitali per ottimizzare le conversioni e migliorare l'esperienza utente sulla tua piattaforma. Analisi dei dati, pianificazione mirata e risultati concreti per far crescere il tuo progetto giorno dopo giorno.
      </>
    </Fixed>
  </React.StrictMode>,
  comeNasceElement
);
const contattiElement = document.getElementById("contatti");
render(
  <React.StrictMode>
    <Fixed extraClasses="p">
      <>
        <h1>Sviluppo Web e Design Moderno</h1>
        
        <p>
          C'era un tempo in cui la progettazione delle interfacce seguiva regole rigide e geometriche. 
          Oggi, l'equilibrio tra spazi vuoti, contrasti cromatici e leggibilità definisce il successo 
          di un'applicazione web.
        </p>

        <h2>I Nostri Servizi</h2>
        
        <p>
          Massimizza il valore del tuo business con soluzioni innovative e su misura. 
          Sviluppiamo strategie digitali per ottimizzare le conversioni e migliorare l'esperienza utente.
        </p>

        <div>
            Scopri di più ed entra in contatto →
        </div>

      </>
    </Fixed>
  </React.StrictMode>,
  contattiElement
);
